import { Component } from "@opten/compiler/metadata/component";
@Component({ className: "js-track-download" })
export class DownloadTracker {
	constructor(private element: HTMLElement) {
		this.element.addEventListener("click", (e) => {
			const target = e.currentTarget as HTMLElement;
			const eventType =
				target.getAttribute("data-event-type") || "download";
			const fileName = target.getAttribute("data-event-url") || "unknown";
			const fileTitle =
				target.getAttribute("data-event-title") || "unknown";

			try {
				dataLayer.push({
					event: eventType,
					download_title: fileTitle,
					download_url: fileName,
				});
			} catch (error) {
				console.warn("gtag is not defined");
			}
		});
	}
}
